import {
  Editor
} from 'slate';

import HelptapEditor from '../../helpers';
import types from '../../elements/types';

function withSchema(editor) {
  const { normalizeNode } = editor;

  editor.normalizeNode = entry => {

    const [node, path] = entry;

    if (node.type === types.DATA_COLLECTION_ROW) {

      const nodeEntry = Editor.above(editor, {
        at: path,
        match: n => {
          return n.type === types.DATA_COLLECTION;
        }
      });

      if (nodeEntry) {
        const [dataCollectionNode, dataCollectionPath] = nodeEntry;
        const refreshed = HelptapEditor.dataCollection.tryRefreshNode(editor, dataCollectionNode, dataCollectionPath, node);

        if (refreshed === true) {
          return;
        }

      }

    }

    // If no schema violations, continue with the next normalization rule
    normalizeNode(entry);
  };

  return editor;
};

export default withSchema;